export const CONSENTIMIENTO_DEPILACION_LASER = `
CONSENTIMIENTO INFORMADO PARA EL TRATAMIENTO DE DEPILACIÓN LÁSER

Yo, {{CLIENTE_NOMBRE_COMPLETO}}, con fecha de nacimiento {{FECHA_NACIMIENTO}} y número de licencia {{CLIENTE_LICENCIA}}, por la presente autorizo a NAT SPA & WELLNESS CENTER, mediante su personal especializado, a realizar en mi persona tratamientos estéticos de depilación láser BLEND DE 755NM, 810NM y 1064NM.

He sido clara y suficientemente informado/a sobre la naturaleza, objetivos, riesgos y alternativas del tratamiento, y he recibido esta información en términos comprensibles. Entiendo que no se me garantiza un resultado específico.

1. Entiendo que el tratamiento requerirá múltiples sesiones debido a la naturaleza del ciclo del crecimiento del vello.
2. He sido informado/a sobre posibles reacciones adversas como enrojecimiento, sensibilidad o incluso quemaduras leves (hasta un 2% de los casos según literatura médica).
3. El centro está disponible para seguimiento gratuito en caso de reacciones, y me comprometo a seguir sus recomendaciones.
4. Acepto usar gafas de protección durante el procedimiento.
5. He provisto información clínica completa, incluyendo exposición solar y tratamientos recientes.
6. Me comprometo a mantener actualizada mi información médica en futuras sesiones.
7. Acepto seguir las instrucciones recomendadas antes y después del tratamiento.
8. Autorizo la toma de fotografías o videos para fines clínicos y seguimiento.
9. Entiendo que cualquier incumplimiento de instrucciones puede aumentar el riesgo de reacciones adversas.
10. Confirmo que he leído, entendido y aceptado este consentimiento voluntariamente.

{{TEXTO_TUTOR}}

Fecha del consentimiento: {{FECHA_FIRMA}}

Al marcar la casilla de aceptación, {{CLIENTE_NOMBRE_COMPLETO}} manifiesta su consentimiento total a los términos aquí descritos, conforme a la Ley de Firma Electrónica de PR y disposiciones contractuales vigentes.
`.trim();
// Texto adicional para menores
export const TEXTO_TUTOR_MENOR = `
Este consentimiento ha sido otorgado por el tutor legal {{TUTOR_NOMBRE}}, con licencia {{TUTOR_LICENCIA}}, en representación del menor.
`.trim();

// Identificación del documento
export const CONSENTIMIENTO_DEPILACION_LASER_ID = "consentimiento_laser";

// Versión del documento legal
export const CONSENTIMIENTO_DEPILACION_LASER_VERSION = "v1.0";